import React from "react";
import { Field } from "react-final-form";
import { formRow } from "../common.css.js";
import TextAreaInput from "./TextAreaInput.js";

interface Props {
    validator?: (value: string) => string | undefined;
    name: string;
    label: string;
    required?: boolean;
    placeholder?: string;
}
const TextAreaField: React.FC<Props> = ({
    validator,
    name,
    label,
    required,
    placeholder,
}) => {
    if (required) label = label + " *";
    return (
        <div className={formRow}>
            <label>{label}</label>
            <Field
                name={name}
                component={TextAreaInput}
                placeholder={placeholder}
                validate={validator}
            />
        </div>
    );
};

export default TextAreaField;
